import { useContext } from 'react';
import { ConfigContext } from './Provider';
import { EnhanchedConfig } from './types';

export const useConfig = (): EnhanchedConfig => {
  return useContext(ConfigContext);
};
